onDomReady(() => {
   $$('.keyboard-shortcuts').addEvent('click', () => {
      import('Shared/modal').then(({ Modal }) => {
         Modal.open({
            type: 'element',
            element: $('shortcuts-modal'),
         });
      });
   });
});
